export const getSupportCode = (str: string) => {
  const parts = str.split(',');
  const parts1 = parts[0].split('-');
  const parts2 = parts[1].split('-');

  return parts1[0] + parts1[1] + parts2[2] + parts2[3] + parts2[4];
};
